import { createStore } from "vuex"
import {login,register,forgotpassword,resetpassword} from "@/API/API";
import httpClient from "@/API/HttpClient";
//import { errorToast } from '@/toast'
import { useToast } from 'vue-toastification'
import router from '@/router/index.js'
const toast = useToast()
export default createStore({
    modules: {
    },
    state: {
        token: localStorage.getItem('token'),
        user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
        slug: localStorage.getItem('slug'),
        loading: false,
        //defcontry: localStorage.getItem('defcontry'),
        UserAppDomain:'http://localhost:8083/'
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
            localStorage.setItem('token', token);
        },
        REMOVE_TOKEN(state) {
            state.token = '';
            //localStorage.removeItem('token')
        },
        SET_USER(state, user) {
            state.user = user
            localStorage.setItem('user', JSON.stringify(user))
        },
        SET_SLUG(state, slug) {
            state.slug = slug;
            localStorage.setItem('slug', slug);
        },
        /*SET_DEFCountry(state, defcontry) {
            state.defcontry = defcontry
            localStorage.setItem('defcontry', defcontry)
          },*/
        on(state) {
            state.loading = true;
          },
          off(state) {
            state.loading = false;
          },
    },
    actions: {
        login({commit}, {mobile, password}) {
            const params = new FormData()
            params.append('Mobile', mobile)
            params.append('Password', password)
            //console.log(password)
            //console.log(mobile)

            //toast.success("به پنل ادمین منو خوش آمدید")
            //login(mobile,password)

            return new Promise((resolve, reject) => {
                login(mobile,password)
                    .then(resp => {
                        toast.success("به پنل ادمین منو خوش آمدید")
                       /*httpClient.defaults.headers.common['Authorization'] = 'Bearer ' +resp.data.result.jwtToken
                       console.log(httpClient.defaults.headers.common['Authorization'])
                       //commit('SET_TOKEN', resp.data.result.jwtToken)
                       commit('SET_TOKEN', resp.data.jwtToken)
                       //if(resp.data.result.slug!=null)
                       //if(resp.data.slug!=null)
                       if(resp.data.slug!=null)
                           //commit('SET_SLUG', resp.data.result.slug)
                           commit('SET_SLUG', resp.data.slug)
                        else{
                            commit('SET_SLUG', '')
                        }*/
                        //toast.success("خطا خطا")
                        httpClient.defaults.headers.common['Authorization'] = 'Bearer ' +resp.data.jwtToken
                       console.log(httpClient.defaults.headers.common['Authorization'])
                       commit('SET_TOKEN', resp.data.jwtToken)
                       if(resp.data.slug!=null)
                           commit('SET_SLUG', resp.data.slug)
                        else{
                            commit('SET_SLUG', '')
                        }   
                       resolve()
                        /*getUserInfo()
                            .then(resp => {
                                fcmToken().then(token => postFCMToken(token))
                                commit("SET_USER", resp.data.result)
                                resolve()
                            })
                            .catch(() => reject())*/
                    })
                    .catch((e) =>{ 
                        console.log(7777)
                        console.log(e)
                        toast.error(e.response.data.Message)
                        //toast.error("شماره موبایل یا رمز اشتباه است")
                        reject()
                    })
            });
        },
        // eslint-disable-next-line no-unused-vars
        register({commit}, {firstName,lastName,mobile, password,confirmPassword,acceptTerms}) {
         //console.log(mobile);
            return new Promise((resolve, reject) => {
                register(firstName,lastName,mobile, password,confirmPassword,acceptTerms)
                
                    // eslint-disable-next-line no-unused-vars
                    .then(resp => {
                        console.log(resp)
                        resolve()
                    })
                    .catch((e) =>{ 
                        console.log(e)
                      toast.error(e.response.data.Message)
                        reject(e)
                    })
            });
        },
        // eslint-disable-next-line no-unused-vars
        forgotpassword({commit}, {mobile}) {
            return new Promise((resolve, reject) => {
                forgotpassword(mobile)
                    // eslint-disable-next-line no-unused-vars
                    .then(resp => {
                        resolve()
                    })
                    .catch((e) =>{ 
                      toast.error(e.message)
                        reject()
                    })
            });
        },
                // eslint-disable-next-line no-unused-vars
        resetpassword({commit}, {token,password,confirmPassword}) {
            return new Promise((resolve, reject) => {
                resetpassword(token,password,confirmPassword)
                    // eslint-disable-next-line no-unused-vars
                    .then(resp => {
                        resolve()
                    })
                    .catch((e) =>{ 
                        toast.error(e.message)
                        reject()
                    })
            });
        },
        logout({commit}) {
            commit('REMOVE_TOKEN')
            router.push('/login')
        },
      
        
    },
    getters: {
        isLoggedIn: state => state.token !== '',
        isShopRegister: state => state.slug !== '',
        token: state => 'Bearer ' + state.token,
        slug: state => state.slug,
        //DEFCountry: state => state.defcontry,
    }
    
})


